import { Box } from '@mui/material';

const DividingLine = () => (
    <Box
        data-testid="dividing-line"
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
            borderLeft: '1px',
            borderLeftStyle: 'solid',
            borderLeftColor: 'grey.200',
        }}
    />
);

export default DividingLine;
